export default __webpack_public_path__ + "static/Skarzynski Piotr-a71105521812b4bc1e3091208c1336f6.jpeg";